import request from '@/axios/axios'

// 查询
export function queryList(query, sysType) {
  return request({
    url: '/system/tradingMailSwitch/queryPage',
    method: 'post',
    data: query,
    sysType: sysType
  })
}
// 修改
export function updateSwitchInfo(query, sysType) {
  return request({
    url: '/system/tradingMailSwitch/update',
    method: 'post',
    data: query,
    sysType: sysType
  })
}

// 启用、禁用API代收
export function updateSwitchFlagByApiPay(query) {
  return request({
    url: '/system/tradingMailSwitch/updateSwitchFlagByApiPay',
    method: 'post',
    data: query
  })
}

// 启用、禁用API代付
export function updateSwitchFlagByApiRemit(query) {
  return request({
    url: '/system/tradingMailSwitch/updateSwitchFlagByApiRemit',
    method: 'post',
    data: query
  })
}

// 启用、禁用后台充值
export function updateSwitchFlagByWebPay(query) {
  return request({
    url: '/system/tradingMailSwitch/updateSwitchFlagByWebPay',
    method: 'post',
    data: query
  })
}

// 启用、禁用后台下发
export function updateSwitchFlagByWebRemit(query) {
  return request({
    url: '/system/tradingMailSwitch/updateSwitchFlagByWebRemit',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/manage/merchantManage/tradingSwitch.js